export default __webpack_public_path__ + "static/media/ID_1.1d5b87d7.webm";